import React, { useEffect, useState } from 'react'
import { getPlatformFeeProgram, type PlatformFeeProgram } from '../../../api/payouts'
import { PlatformFeeProgramCard } from './Payouts'

export default function CreatorPlatformFeeProgramPage() {
  const [program, setProgram] = useState<PlatformFeeProgram | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    void (async () => {
      setLoading(true)
      setError(null)
      try {
        const payload = await getPlatformFeeProgram()
        if (!cancelled) setProgram(payload)
      } catch (e: any) {
        if (!cancelled) setError(e?.response?.data?.detail || e?.message || 'Failed to load platform fee program.')
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-extrabold">Platform Fee Program</h1>
        <div className="text-sm text-white/70">Reduce your platform fee as your reputation grows.</div>
        <div className="text-xs text-white/55">Reputation is required for fee reductions.</div>
      </div>
      <div className="text-xs text-white/60">Applies to bookings and subscriptions. Gifts are excluded.</div>
      {error ? <div className="rounded-xl border border-rose-500/25 bg-rose-500/10 p-4 text-sm text-rose-200">{error}</div> : null}
      {loading && !program ? (
        <div className="rounded-xl border border-white/10 bg-white/5 p-4 text-sm text-white/70">Loading platform fee program...</div>
      ) : null}
      <PlatformFeeProgramCard program={program} />
    </div>
  )
}
